import { createContext, useContext } from 'react';
import { Conversation } from 'src/graphql';

export interface ConversationEntityContextValue {
  conversation: Conversation;
  onUpdate: (conversation: Conversation) => Promise<void>;
  canEdit: boolean;
}

export const ConversationEntityContext = createContext<ConversationEntityContextValue | null>(
  null,
);

export function useConversationEntity(): ConversationEntityContextValue {
  const value = useContext(ConversationEntityContext);

  if (!value) {
    throw new Error('useConversationEntity must be used within ConversationSidePanelProvider');
  }

  return value;
}
